"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnauthorizedError = exports.AuthError = void 0;
exports.isUnauthorizedError = isUnauthorizedError;
class AuthError extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
    }
}
exports.AuthError = AuthError;
class UnauthorizedError extends AuthError {
    constructor(message = 'Authentication required') {
        super(message);
    }
}
exports.UnauthorizedError = UnauthorizedError;
function isUnauthorizedError(error) {
    return error instanceof UnauthorizedError;
}
//# sourceMappingURL=authentication.errors.js.map